import { downloadStockTemplate } from './downloadStockTemplate'
import { validateInconsistencies } from './validateInconsistencies'
import { saveStep } from './saveStep'
import { saveValidateData } from './saveValidateData'
import { checkStockMassiveUpload } from './checkStockMassiveUpload'
import { confirmStockImportation } from './confirmStockImportation'
import { downloadSummary } from './downloadSummary'
import { Dictionary } from './BFF_dictionary'
import { getPaginatedListStock } from './getPaginatedListStock';
import { TakingCarManagement } from './BFF_takingCarManagement'

export const Stock = {
  downloadStockTemplate,
  validateInconsistencies,
  saveStep,
  saveValidateData,
  checkStockMassiveUpload,
  confirmStockImportation,
  downloadSummary,
  Dictionary,
  getPaginatedListStock,
  TakingCarManagement
}
